export const partBomListPath = (query = '') => `/part-bom/list${query ? `?query=${query}` : ''}`;
